<template>
	<div class="seccion-header">
		<div v-for="item in items" :key="item">
			<div class="container-text">
				<img src="/static/images-new/icons/check-orange.svg" alt="check" height="14" class="mr-2">
				<span>{{ item }}</span>
			</div>
		</div>
	</div>
</template>
<script>
function data() {
	return {
		items: [
			'Incrementa tus ventas y fideliza tus clientes',
			'Ten Múltiples Canales de Venta + Facturación Electrónica',
			'Potencia la Gestión de tu Empresa',
		],
	};
}
export default {
	name: 'seccion-header',
	data,
};
</script>
<style lang="scss" scoped>
	.seccion-header {
		align-items: center;
		background: color(white);
		display: flex;
		flex-wrap: wrap;
		justify-content: space-around;
		padding: 20px 10%;

		@media (max-width: 936px) {
			display: none;
		}
	}

	.container-text {
		align-items: center;
		border: 1px solid color(newprimary);
		border-radius: 5px;
		color: color(primary);
		display: flex;
		height: 54px;
		margin: 5px;
		padding: 5px 9px;
		width: 240px;
	}
</style>


// WEBPACK FOOTER //
// src/components/advisers/seccion-header.vue